import { usePharmacyStores, useHasMultipleStores } from './usePharmacyStores';

/**
 * Store filter for read screens (Inventory, Near Expiry). `undefined` = every
 * store at the branch. Hidden at a single-store branch.
 */
export function StorePicker({ value, onChange, label = 'Store' }: {
  value: number | undefined;
  onChange: (storeId: number | undefined) => void;
  label?: string;
}) {
  const { data } = usePharmacyStores();
  const multiple = useHasMultipleStores();
  if (!multiple || !data) return null;
  return (
    <label className="inline-flex items-center gap-2 text-[13px] text-muted-foreground">
      <span>{label}</span>
      <select
        className="h-9 w-auto min-w-[160px] rounded-[var(--radius)] border border-input bg-card px-2 text-[13px] text-foreground"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : undefined)}
      >
        <option value="">All stores</option>
        {data.stores.filter((s) => s.active || s.units_in_stock > 0).map((s) => (
          <option key={s.id} value={s.id}>{s.name}{s.active ? '' : ' (inactive)'}</option>
        ))}
      </select>
    </label>
  );
}
